<div class="header-bar">
  <h1>Long distance time-bands</h1>
</div>
<div class="">
  <div class="content-container" *ngIf="timeBands">
    <p-table
      [value]="timeBands"
      [lazy]="true"
      [responsive]="true"
      [paginator]="false"
      rowHover="true"
      resizableColumns="false"
      [(selection)]="selectedTimeBand"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Time Band</th>
          <th>Add-on Price</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item" (click)="onRowClick($event)">
          <td>
            <input
              pInputText
              [(ngModel)]="item.timeBand"
              (change)="cellEdit(item, 0)"
              [minVal]="0"
              [maxVal]="50"
              decimalDigits
              [ngModelOptions]="{ standalone: true }"
              appendTo="body"
            />
          </td>
          <td>
            <input
              pInputText
              [(ngModel)]="item.addOnPrice"
              (change)="cellEdit(item, 1)"
              [minVal]="0"
              [maxVal]="1000"
              decimalDigits
              [ngModelOptions]="{ standalone: true }"
              appendTo="body"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!--- DATATABLES DEPRECATED
      <p-dataTabl [value]="timeBands" [lazy]="true" [responsive]="true" [paginator]="false"
                   rowHover="true" resizableColumns="false" (onRowClick)="onRowClick($event)"
                   [editable]="tru" [(selection)]="selectedTimeBand"
                   [hidden]="!isLoaded">
        <p-column field="timeBand" header="Time Band" [sortable]="true" [editabl]="true" [style]="{'width': '45%'}">
          <ng-template let-item="rowData" pTemplate="editor">
            <input pInputText [(ngModel)]="item.timeBand"
                   (change)="cellEdit(item, 0)" [minVal]="0" [maxVal]="50" decimalDigits
                   [ngModelOptions]="{standalone: true}" appendTo="body" />
          </ng-template>
        </p-column>
        <p-column field="addOnPrice" header="Add-on Price" [sortable]="true" [editabl]="true" [style]="{'width': '45%'}">
          <ng-template let-item="rowData" pTemplate="editor">
            <input pInputText [(ngModel)]="item.addOnPrice"
                   (change)="cellEdit(item, 1)" [minVal]="0" [maxVal]="1000" decimalDigits
                   [ngModelOptions]="{standalone: true}" appendTo="body" />
          </ng-template>
        </p-column>
      </p-dataTable>
      -->

    <div class="footerPanel ui-grid-row">
      <button
        type="button"
        pButton
        icon="fa ui-icon-add"
        (click)="addTimeBand()"
        label="Add"
        class="btn-to-right ui-button-primary"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-trash"
        class="ui-button ui-button-danger btn-to-right"
        label="Delete"
        (click)="deleteTimeBand()"
        [disabled]="!selectedTimeBand"
      ></button>
    </div>
  </div>
</div>

<p-dialog
  header="Add Long distance time-band"
  [(visible)]="showAddTimeBandDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-4">Time band</div>
    <div class="ui-grid-col-8">
      <input pInputText [(ngModel)]="addItem.timeBand" [minVal]="0" [maxVal]="24" />
    </div>
  </div>

  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-4">Add-on Price</div>
    <div class="ui-grid-col-8">
      <input
        pInputText
        [(ngModel)]="addItem.addOnPrice"
        [minVal]="0"
        [maxVal]="500"
        decimalDigits
      />
    </div>
  </div>

  <div class="ui-grid-row" style="margin-top: 20px">
    <button
      type="button"
      (click)="showAddTimeBandDlg = false"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      class="ui-button btn-to-right"
    ></button>

    <button
      type="button"
      (click)="saveTimeBand(addItem)"
      pButton
      label="Save"
      [disabled]="!(addItem.timeBand && addItem.addOnPrice)"
      class="ui-button green-btn btn-to-right"
    ></button>
  </div>
</p-dialog>

<p-dialog
  header="Delete Time Band"
  [(visible)]="showDeleteTimeBandDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-12">Are you sure want to delete selected item?</div>
  </div>

  <div class="ui-grid-row" style="margin-top: 20px">
    <button
      type="button"
      (click)="showDeleteTimeBandDlg = false"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      class="ui-button btn-to-right"
    ></button>

    <button
      type="button"
      (click)="deleteTimeBandConfirm(selectedTimeBand)"
      pButton
      label="Confirm"
      class="ui-button green-btn btn-to-right"
    ></button>
  </div>
</p-dialog>
